// extracted by mini-css-extract-plugin
export default {"circular-progress-bar":"ProgressBarCircular_circular-progress-bar__CS86t","value-progress-bar":"ProgressBarCircular_value-progress-bar__J0BpI"};